import React, { Fragment, useState, useEffect, useRef } from "react";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import { Button, Collapse } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlusCircle,
  faAsterisk,
  faPlus,
  faSave,
  faTrash,
  faTimes,
  faTimesCircle,
  faCheckCircle,
  faMinusCircle,
} from "@fortawesome/free-solid-svg-icons";
import AppSidebar from "../../../Layout/AppSidebar";
import "./Configuration.css";
import swal from "sweetalert";

const ConfigurationList = () => {
  const [goalNameType, setGoalNameType] = useState(false);
  const [name, setName] = useState(false);
  const [operator, setOperator] = useState(false);
  const [arithemeticOperator, setArithemeticOperator] = useState(false);
  const [dataType, setDataType] = useState(false);
  const [goalTypeData, setGoalTypeData] = useState([]);
  const [expressionData, setExpressionData] = useState([]);
  const [arithemeticData, setArithemeticData] = useState([]);
  const [typeData, setTypeData] = useState([]);
  const [operatorData, setOperatorData] = useState([]);
  const [manual, setManual] = useState();
  const valueNameRef = useRef();
  const timeoutRef = useRef();

  const [query, setQuery] = useState();
  const [queryChange, setQueryChange] = useState();
  const [queryData, setQueryData] = useState([]);
  const [reason, setReason] = useState();
  const [reasonChange, setReasonChange] = useState();
  const [reasonData, setReasonData] = useState([]);
  const [manualChange, setManualChange] = useState();
  const [manualData, setManualData] = useState([]);
  const [gender, setGender] = useState();
  const [genderChange, setGenderChange] = useState();
  const [genderData, setGenderData] = useState([]);
  const [ethnicity, setEthnicity] = useState();
  const [ethnicityChange, setEthnicityChange] = useState();
  const [ethnicityData, setEthnicityData] = useState([]);
  const [interest, setInterest] = useState();
  const [interestChange, setInterestChange] = useState();
  const [interestData, setInterestData] = useState([]);
  const [athletics, setAthletics] = useState();
  const [country, setCountry] = useState();
  const [certificate, setCertificate] = useState();
  const [english, setEnglish] = useState();
  const [level, setLevel] = useState();
  const [athleticsChange, setAthleticsChange] = useState();
  const [countryChange, setCountryChange] = useState();
  const [certificateChange, setCertificateChange] = useState();
  const [englishChange, setEnglishChange] = useState();
  const [levelChange, setLevelChange] = useState();
  const [athleticsData, setAthleticsData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [certificateData, setCertificateData] = useState([]);
  const [englishData, setEnglishData] = useState([]);
  const [levelData, setLevelData] = useState([]);
  const [academics, setAcademics] = useState();
  const [academicsChange, setAcademicsChange] = useState();
  const [academicsData, setAcademicsData] = useState([]);
  const [activities, setActivities] = useState();
  const [activitiesChange, setActivitiesChange] = useState();
  const [activitiesData, setActivitiesData] = useState([]);
  const [course, setCourse] = useState();
  const [courseChange, setCourseChange] = useState();
  const [courseData, setCourseData] = useState([]);
  const [valueName, setValueName] = useState();

  const [valueNameList, setValueNameList] = useState();
  const [valueNameLoading, setValueNameLoading] = useState(false);

  const goalType = () => {
    return setGoalNameType(!goalNameType);
  };
  const goalName = () => {
    return setName(!name);
  };
  const operatorName = () => {
    return setOperator(!operator);
  };
  const arithemeticOperators = () => {
    return setArithemeticOperator(!arithemeticOperator);
  };
  const dataTypeName = () => {
    return setDataType(!dataType);
  };

  const queryCriterias = () => {
    return setQuery(!query);
  };

  const contactReason = () => {
    return setReason(!reason);
  };

  const manualName = () => {
    return setManual(!manual);
  };

  const genderName = () => {
    return setGender(!gender);
  };

  const ethnicityName = () => {
    return setEthnicity(!ethnicity);
  };

  const courseName = () => {
    return setCourse(!course);
  };

  const interestName = () => {
    return setInterest(!interest);
  };

  const academicsName = () => {
    return setAcademics(!academics);
  };

  const athleticsName = () => {
    return setAthletics(!athletics);
  };

  const countryName = () => {
    return setCountry(!country);
  }

  const certificateName = () => {
    return setCertificate(!certificate)
  }

  const englishName = () => {
    return setEnglish(!english)
  }

  const levelName = () => {
    return setLevel(!level)
  }

  const activitiesName = () => {
    return setActivities(!activities);
  };

  const cancelAction = () => {
    window.location.reload();
  };

  const asArray = (value) => (Array.isArray(value) ? value : []);

  const getApiErrorMessage = (error) => {
    const data = error?.response?.data;
    let raw =
      (typeof data === "string" && data) ||
      data?.error ||
      data?.error_message ||
      data?.message ||
      data?.detail ||
      (Array.isArray(data) ? data.join(", ") : null) ||
      error?.message ||
      "Something went wrong. Please try again.";

    if (raw && typeof raw === "object") {
      raw =
        raw.error ||
        raw.message ||
        raw.detail ||
        JSON.stringify(raw);
    }

    const text = String(raw || "Something went wrong. Please try again.");
    const lower = text.toLowerCase();

    if (
      lower.includes("foreign key") ||
      lower.includes("still referenced") ||
      lower.includes("violates foreign key")
    ) {
      return "This item cannot be deleted because it is currently in use. Remove related mappings first, then try again.";
    }

    // Keep alerts readable for long database traces
    return text.length > 320 ? `${text.slice(0, 320)}...` : text;
  };

  const showApiError = (error) => {
    swal({
      text: getApiErrorMessage(error),
      icon: "warning",
      dangerMode: true,
      buttons: { confirm: true },
      closeOnClickOutside: false,
    });
  };

  const showSuccess = (message, onOk) => {
    swal({
      text: message || "Saved successfully.",
      icon: "success",
      buttons: { OK: true },
      closeOnClickOutside: false,
    }).then((value) => {
      if (value === "OK" && onOk) onOk();
    });
  };

  const runSaveRequest = (request, { successMessage, onSuccess } = {}) => {
    return request
      .then((data) => {
        if (data?.data?.error || data?.data?.error_message) {
          showApiError({ response: { data: data.data } });
          return;
        }
        const message =
          successMessage ||
          data?.data?.Status ||
          data?.data?.message ||
          "Saved successfully.";
        showSuccess(message, () => {
          if (onSuccess) onSuccess(data);
          else cancelAction();
        });
      })
      .catch((error) => {
        showApiError(error);
      });
  };

  const confirmAndDelete = async ({
    id,
    itemLabel = "this item",
    deleteRequest,
    onSuccess,
  }) => {
    if (!id) return;
    const confirmed = await swal({
      title: "Delete?",
      text: `Are you sure you want to delete ${itemLabel}?`,
      icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: "Yes, Delete",
      },
      dangerMode: true,
      closeOnClickOutside: false,
    });
    if (!confirmed) return;

    try {
      const data = await deleteRequest(id);
      if (data?.data?.error || data?.data?.error_message) {
        showApiError({ response: { data: data.data } });
        return;
      }
      showSuccess(
        data?.data?.Status || data?.data?.message || "Deleted successfully.",
        () => onSuccess?.()
      );
    } catch (error) {
      showApiError(error);
    }
  };

  const confirmAndToggleActive = async ({
    list,
    index,
    setList,
    itemLabel = "this item",
  }) => {
    const items = asArray(list);
    const current = items[index];
    if (!current) return;

    const nextActive = !current.active;
    const actionLabel = nextActive ? "enable" : "disable";
    const confirmed = await swal({
      title: nextActive ? "Enable?" : "Disable?",
      text: `Are you sure you want to ${actionLabel} ${itemLabel}?`,
      icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: nextActive ? "Yes, Enable" : "Yes, Disable",
      },
      dangerMode: !nextActive,
      closeOnClickOutside: false,
    });
    if (!confirmed) return;

    setList(
      items.map((item, id) =>
        id === index ? { ...item, active: nextActive } : item
      )
    );
  };

  const handleAddGoalType = () => {
    setGoalTypeData([...asArray(goalTypeData), {}]);
  };

  const handleAddExpression = () => {
    setExpressionData([...asArray(expressionData), {}]);
  };

  const handleAddField = () => {
    setTypeData([...asArray(typeData), {}]);
  };

  const handleAddOperator = () => {
    setOperatorData([...asArray(operatorData), {}]);
  };

  const handleArithmeticOpt = () => {
    setArithemeticData([...asArray(arithemeticData), {}]);
  };

  const getNewTypeNames = (list, fieldKey) =>
    asArray(list)
      .filter((item) => !item?.id && !item?.disabled)
      .map((item) => String(item?.[fieldKey] || "").trim())
      .filter(Boolean);

  const warnIfNoNewValues = (values, label = "value") => {
    if (values.length) return false;
    swal({
      text: `Please add at least one new ${label} before saving.`,
      icon: "warning",
      buttons: { confirm: true },
      closeOnClickOutside: false,
    });
    return true;
  };

  const handleSaveType = () => {
    const type_name = getNewTypeNames(goalTypeData, "goalfield_name");
    if (warnIfNoNewValues(type_name, "goal field type")) return;
    runSaveRequest(GetAdminService.saveType({ type_name }), {
      onSuccess: () => goalFieldData(),
    });
  };

  const handleSaveExpression = () => {
    const type_name = getNewTypeNames(expressionData, "expression_name");
    if (warnIfNoNewValues(type_name, "expression name")) return;
    runSaveRequest(GetAdminService.saveExpression({ type_name }), {
      onSuccess: () => goalExpresssionData(),
    });
  };

  const handleSaveArthOperator = () => {
    const type_name = getNewTypeNames(arithemeticData, "operator");
    if (warnIfNoNewValues(type_name, "arithmetic operator")) return;
    runSaveRequest(GetAdminService.saveArthOptr({ type_name }), {
      onSuccess: () => arithemeticShowData(),
    });
  };

  const handleOperatorSave = () => {
    const newOperators = asArray(operatorData)
      .filter(
        (item) =>
          !item?.id &&
          !item?.disabled &&
          String(item?.operator_name || "").trim() &&
          String(item?.operator || "").trim()
      )
      .map((item) => ({
        operator_name: String(item.operator_name).trim(),
        operator: String(item.operator).trim(),
      }));
    if (warnIfNoNewValues(newOperators, "logical operator")) return;

    const payload = { ...newOperators };
    runSaveRequest(GetAdminService.saveOperator(payload), {
      onSuccess: () => operatorShowData(),
    });
  };

  const handleSaveField = () => {
    const type_name = getNewTypeNames(typeData, "field_type");
    if (warnIfNoNewValues(type_name, "data type")) return;
    runSaveRequest(GetAdminService.saveField({ type_name }), {
      onSuccess: () => typeShowData(),
    });
  };

  const goalFieldData = () => {
    GetAdminService.goalFieldData()
      .then((data) => {
        const list = asArray(data?.data?.data);
        const newData = list.map((obj) => ({
          ...obj,
          disabled: true,
        }));
        setGoalTypeData(newData);
      })
      .catch((error) => {
        setGoalTypeData([]);
        showApiError(error);
      });
  };

  const goalFieldDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this goal field type",
      deleteRequest: GetAdminService.deleteGoalFieldData,
      onSuccess: goalFieldData,
    });
  };

  const goalExpresssionData = () => {
    GetAdminService.goalExpressionData()
      .then((data) => {
        const list = asArray(data?.data?.data);
        const newData = list.map((obj) => ({
          ...obj,
          disabled: true,
        }));
        setExpressionData(newData);
      })
      .catch((error) => {
        setExpressionData([]);
        showApiError(error);
      });
  };

  const goalExpresssionDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this expression name",
      deleteRequest: GetAdminService.deletegoalExpresssionData,
      onSuccess: goalExpresssionData,
    });
  };

  const operatorShowData = () => {
    GetAdminService.operatorShowData()
      .then((data) => {
        const list = asArray(data?.data?.data);
        const newData = list.map((obj) => ({
          ...obj,
          disabled: true,
        }));
        setOperatorData(newData);
      })
      .catch((error) => {
        setOperatorData([]);
        showApiError(error);
      });
  };

  const goalOperatorDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this logical operator",
      deleteRequest: GetAdminService.deletegoalOperatorData,
      onSuccess: operatorShowData,
    });
  };

  const typeShowData = () => {
    GetAdminService.typeShowData()
      .then((data) => {
        const list = asArray(data?.data?.data);
        const newData = list.map((obj) => ({
          ...obj,
          disabled: true,
        }));
        setTypeData(newData);
      })
      .catch((error) => {
        setTypeData([]);
        showApiError(error);
      });
  };

  const typeDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this data type",
      deleteRequest: GetAdminService.deletetypeData,
      onSuccess: typeShowData,
    });
  };

  const arithemeticShowData = () => {
    GetAdminService.arithemeticShowData()
      .then((data) => {
        const list = asArray(data?.data?.data);
        const newData = list.map((obj) => ({
          ...obj,
          disabled: true,
        }));
        setArithemeticData(newData);
      })
      .catch((error) => {
        setArithemeticData([]);
        showApiError(error);
      });
  };

  const arithematicDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this arithmetic operator",
      deleteRequest: GetAdminService.deletearithematicData,
      onSuccess: arithemeticShowData,
    });
  };

  const handleAddQuery = () => {
    setQueryData([...asArray(queryData), { id: "", active: true }]);
  };

  const queryDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this query criteria",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const handleAddReason = () => {
    setReasonData([...asArray(reasonData), { id: "", active: true }]);
  };

  const reasonDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this contact reason",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const handleAddManual = () => {
    setManualData([...asArray(manualData), { id: "", active: true}]);
  };

  const manualDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this manual entry",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const handleAddGender = () => {
    setGenderData([...asArray(genderData), { id: "", active: true }]);
  };

  const genderDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this gender option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const handleAddEthnicity = () => {
    setEthnicityData([...asArray(ethnicityData), { id: "", active: true }]);
  };

  const ethnicityDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this ethnicity option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const handleAddInterest = () => {
    setInterestData([...asArray(interestData), { id: "", active: true }]);
  };

  const interestDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this interest option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const handleAddAcademics = () => {
    setAcademicsData([...asArray(academicsData), { id: "", active: true }]);
  };

  const academicsDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this academics option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const handleAddActivities = () => {
    setActivitiesData([...asArray(activitiesData), { id: "", active: true }]);
  };

  const activitiesDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this activities option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const handleAddAthletics = () => {
    setAthleticsData([...asArray(athleticsData), { id: "", active: true }]);
  };

  const handleAddCountry = () => {
    setCountryData([...asArray(countryData), {id: "", active: true}]);
  }

  const handleAddCertificate = () => {
    setCertificateData([...asArray(certificateData), {id: "", active: true}]);
  }

  const handleAddEnglish = () => {
    setEnglishData([...asArray(englishData), {id: "", active: true}]);
  }

  const handleAddLevel = () => {
    setLevelData([...asArray(levelData), {id: "", active: true}]);
  }

  const athleticsDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this athletics option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const countryDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this country option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const certificateDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this certificate option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const englishDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this english option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  const levelDelete = (idToDelete) => {
    confirmAndDelete({
      id: idToDelete,
      itemLabel: "this level option",
      deleteRequest: GetAdminService.deletequeryData,
      onSuccess: queryCriteriasShowData,
    });
  };

  // const concentrationDelete = (idToDelete) => {
  //   confirmAndDelete({
  //     id: idToDelete,
  //     itemLabel: "this concentration option",
  //     deleteRequest: GetAdminService.deletequeryData,
  //     onSuccess: queryCriteriasShowData,
  //   });
  // };

  const queryCriteriasShowData = () => {
    GetAdminService.queryCriteriasShowData()
      .then((data) => {
        const object = data?.data?.object || {};

        setQueryData(asArray(object.query_criteria));
        setReasonData(asArray(object.reasontocontact));
        setManualData(asArray(object.query_criteriamanual));
        setGenderData(asArray(object.gender));
        setEthnicityData(asArray(object.ethnicity));
        setInterestData(asArray(object.intrest));
        setAcademicsData(asArray(object.academics));
        setAthleticsData(asArray(object.athletics));
        setCountryData(asArray(object.country));
        setCertificateData(asArray(object["board certification"]));
        setEnglishData(asArray(object["english test"]));
        setLevelData(asArray(object["desired degree"]));
        setActivitiesData(asArray(object.activities));

        const concentrationSource = Array.isArray(object)
          ? object
          : asArray(object.concentration_name);
        setCourseData(
          concentrationSource.filter(
            (obj) => !obj?.list_name || obj.list_name === "concentration_name"
          )
        );
      })
      .catch((error) => {
        setQueryData([]);
        setReasonData([]);
        setManualData([]);
        setGenderData([]);
        setEthnicityData([]);
        setInterestData([]);
        setAcademicsData([]);
        setAthleticsData([]);
        setCountryData([]);
        setCertificateData([]);
        setEnglishData([]);
        setLevelData([]);
        setActivitiesData([]);
        setCourseData([]);
        showApiError(error);
      });
  };
  const handleAddQueryChange = (e, i) => {
    const { value } = e.target;
    setQueryChange(e.target.value);
    const newQueryData = queryData?.map((q, id) => {
      if (id === i) {
        return { ...q, name: value };
      } else {
      return q;
      }
    });
    setQueryData(newQueryData);
  };

  const handleAddReasonChange = (e, i) => {
    const { value } = e.target;
    setReasonChange(e.target.value);
    const newReasonData = reasonData.map((r, id) => {
      if (id === i) {
        return { ...r, name: value };
      } else {
      return r;
      }
    });
    setReasonData(newReasonData);
  };

  const handleAddManualChange = (e, i) => {
    const { value } = e.target;
    setManualChange(e.target.value);
    const newManualData = manualData.map((m, id) => {
      if (id === i) {
        return { ...m, name: value };
      } else {
      return m;
      }
    });
    setManualData(newManualData);
  };

  const handleAddGenderChange = (e, i) => {
    const { value } = e.target;
    setGenderChange(e.target.value);
    const newGenderData = genderData.map((g, id) => {
      if (id === i) {
        return { ...g, name: value };
      } else {
      return g;
      }
    });
    setGenderData(newGenderData);
  };

  const handleAddEthnicityChange = (e, i) => {
    const { value } = e.target;
    setEthnicityChange(e.target.value);
    const newEthnicityData = ethnicityData.map((e, id) => {
      if (id === i) {
        return { ...e, name: value };
      } else {
      return e;
      }
    });
    setEthnicityData(newEthnicityData);
  };

  const handleAddInterestChange = (e, i) => {
    const { value } = e.target;
    setInterestChange(e.target.value);
    const newInterestData = interestData.map((s, id) => {
      if (id === i) {
        return { ...s, name: value };
      } else {
      return s;
       }
    });
    setInterestData(newInterestData);
  };

  const handleAddInterestDisabled = (i) => {
    confirmAndToggleActive({
      list: interestData,
      index: i,
      setList: setInterestData,
      itemLabel: "this interest option",
    });
  };

  const handleAddAcademicsChange = (e, i) => {
    const { value } = e.target;
    setAcademicsChange(e.target.value);
    const newAcademicsData = academicsData.map((j, id) => {
      if (id === i) {
        return { ...j, name: value };
      } else {
      return j;
      }
    });
    setAcademicsData(newAcademicsData);
  };

  const handleAddAcademicsDisabled = (i) => {
    confirmAndToggleActive({
      list: academicsData,
      index: i,
      setList: setAcademicsData,
      itemLabel: "this academics option",
    });
  };

  const handleAddAthleticsChange = (e, i) => {
    const { value } = e.target;
    setAthleticsChange(e.target.value);
    const newAthleticsData = athleticsData.map((t, id) => {
      if (id === i) {
        return { ...t, name: value };
      } else {
      return t;
      }
    });
    setAthleticsData(newAthleticsData);
  };

  const handleAddAthleticsDisabled = (i) => {
    confirmAndToggleActive({
      list: athleticsData,
      index: i,
      setList: setAthleticsData,
      itemLabel: "this athletics option",
    });
  };

  const handleAddCountryChange = (e, i) => {
    const { value } = e.target;
    setCountryChange(e.target.value);
    const newCountryData = countryData.map((t, id) => {
      if (id === i) {
        return { ...t, name: value };
      } else {
      return t;
      }
    });
    setCountryData(newCountryData);
  };

  const handleAddCountryDisabled = (i) => {
    confirmAndToggleActive({
      list: countryData,
      index: i,
      setList: setCountryData,
      itemLabel: "this country option",
    });
  };

  const handleAddCertificateChange = (e, i) => {
    const { value } = e.target;
    setCertificateChange(e.target.value);
    const newCertificateData = certificateData.map((t, id) => {
      if (id === i) {
        return { ...t, name: value };
      } else {
      return t;
      }
    });
    setCertificateData(newCertificateData);
  };

  const handleAddCertificateDisabled = (i) => {
    confirmAndToggleActive({
      list: certificateData,
      index: i,
      setList: setCertificateData,
      itemLabel: "this certificate option",
    });
  };

  const handleAddEnglishChange = (e, i) => {
    const { value } = e.target;
    setEnglishChange(e.target.value);
    const newEnglishData = englishData.map((t, id) => {
      if (id === i) {
        return { ...t, name: value };
      } else {
      return t;
      }
    });
    setEnglishData(newEnglishData);
  };

  const handleAddEnglishDisabled = (i) => {
    confirmAndToggleActive({
      list: englishData,
      index: i,
      setList: setEnglishData,
      itemLabel: "this english option",
    });
  };

  const handleAddLevelChange = (e, i) => {
    const { value } = e.target;
    setLevelChange(e.target.value);
    const newLevelData = levelData.map((t, id) => {
      if (id === i) {
        return { ...t, name: value };
      } else {
      return t;
      }
    });
    setLevelData(newLevelData);
  };

  const handleAddLevelDisabled = (i) => {
    confirmAndToggleActive({
      list: levelData,
      index: i,
      setList: setLevelData,
      itemLabel: "this level option",
    });
  };

  

  const handleAddActivitiesChange = (e, i) => {
    const { value } = e.target;
    setActivitiesChange(e.target.value);
    const newActivitiesData = activitiesData.map((p, id) => {
      if (id === i) {
        return { ...p, name: value };
      } else {
      return p;
      }
    });
    setActivitiesData(newActivitiesData);
  };

  const handleAddActivitiesDisabled = (i) => {
    confirmAndToggleActive({
      list: activitiesData,
      index: i,
      setList: setActivitiesData,
      itemLabel: "this activities option",
    });
  };

  const handleSaveCriteria = (e) => {
    let obj = {
      list_name: "query_criteria",
      name: {...queryData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveReason = () => {
    let obj = {
      list_name: "reasontocontact",
      name: {...reasonData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveManual = () => {
    let obj = {
      list_name: "query_criteriamanual",
      name: {...manualData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveGender = () => {
    let obj = {
      list_name: "gender",
      name: {...genderData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveEthnicity = () => {
    let obj = {
      list_name: "ethnicity",
      name: {...ethnicityData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveInterest = () => {
    let obj = {
      list_name: "intrest",
      // name: interestChange,
       name: {...interestData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveAcademics = () => {
    let obj = {
      list_name: "academics",
      // name: academicsChange,
      name: {...academicsData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveActivities = () => {
    let obj = {
      list_name: "activities",
      // name: activitiesChange,
      name: {...activitiesData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveAthletics = () => {
    let obj = {
      list_name: "athletics",
      // name: athleticsChange,
      name: {...athleticsData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveCountry = () => {
    let obj = {
      list_name: "country",
      // name: athleticsChange,
      name: {...countryData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveCertificate = () => {
    let obj = {
      list_name: "board certification",
      // name: athleticsChange,
      name: {...certificateData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveEnglish = () => {
    let obj = {
      list_name: "english test",
      // name: athleticsChange,
      name: {...englishData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const handleSaveLevel = () => {
    let obj = {
      list_name: "desired degree",
      // name: athleticsChange,
      name: {...levelData},
    };
    runSaveRequest(GetAdminService.saveCriteria(obj), {
      onSuccess: () => queryCriteriasShowData(),
    });
  };

  const getCourseList = (value) => {
    setValueNameLoading(true);
    GetAdminService.getCourseList(value)
      .then((data) => {
        setValueNameList(data?.data?.objects);

        setValueNameLoading(false);
        // setShowSchoolNameContainer(true);
      })
      .catch((error) => {
        setValueNameLoading(false);
        setValueNameList([]);
        showApiError(error);
      });
  };

  const handleChangeConcentration = (index) => {
    clearTimeout(timeoutRef.current);
    setValueName(valueNameRef.current.value);
    const arr = courseData.map((s, id) => {
      if (id === index) {
        return { ...s, goal: valueNameRef.current.value };
      } else {
        return s;
      }
    });
    setCourseData([...arr]);
    if (!valueNameRef.current.value) {
      // setShowSchoolNameContainer(false);
      setValueNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getCourseList(valueNameRef.current.value);
      }, 1000);
    }
  };

  const handleAddCourse = () => {
    setCourseData([...courseData, { name: "", goal: "", goals: "", id: "" }]);
  };

  const handleAddConcentrationChange = (e, i) => {
    const { value } = e.target;
    setCourseChange(e.target.value);
    const arr = courseData.map((s, id) => {
      if (id === i) {
        return { ...s, name: value };
      } else {
        return s;
      }
    });
    setCourseData([...arr]);
  };

  // const handleSaveCourse = () => {
  //   let obj = {
  //     list_name: "concentration_name",
  //     name: { ...courseData },
  //   };
  //   GetAdminService.saveCourse(obj).then((data) => {
  //     cancelAction();
  //   });
  // };

  const handleGoalType = (e, index) => {
    const value = e.target.value;
    setGoalTypeData((prev) =>
      asArray(prev).map((item, i) =>
        i === index ? { ...item, goalfield_name: value } : item
      )
    );
  };

  const handleExpressionName = (e, index) => {
    const value = e.target.value;
    setExpressionData((prev) =>
      asArray(prev).map((item, i) =>
        i === index ? { ...item, expression_name: value } : item
      )
    );
  };

  const handleOperatorChange = (e, index) => {
    const value = e.target.value;
    setOperatorData((prev) =>
      asArray(prev).map((item, i) =>
        i === index ? { ...item, operator_name: value } : item
      )
    );
  };

  const handleOperatorChange1 = (e, index) => {
    const value = e.target.value;
    setOperatorData((prev) =>
      asArray(prev).map((item, i) =>
        i === index ? { ...item, operator: value } : item
      )
    );
  };

  const handleArithematicChange = (e, index) => {
    const value = e.target.value;
    setArithemeticData((prev) =>
      asArray(prev).map((item, i) =>
        i === index ? { ...item, operator: value } : item
      )
    );
  };

  const handleDataType = (e, index) => {
    const value = e.target.value;
    setTypeData((prev) =>
      asArray(prev).map((item, i) =>
        i === index ? { ...item, field_type: value } : item
      )
    );
  };

  useEffect(() => {
    goalFieldData();
    goalExpresssionData();
    operatorShowData();
    arithemeticShowData();
    typeShowData();
    queryCriteriasShowData();
  }, []);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="admin-config-page">
            <div className="admin-config-header">
              <div>
                <h1 className="admin-config-title">Configurations</h1>
                <p className="admin-config-subtitle">
                  Manage student progress and data source configuration lists
                </p>
              </div>
            </div>
            <div className="admin-config-section">
              <h2 className="admin-config-section-title">
                Configuration for Student Progress
              </h2>
              <div className="admin-config-accordion-list">
                <p className="shade" onClick={goalType}>
                  Add Goal Field Type
                  <FontAwesomeIcon
                    icon={!goalNameType ? faPlusCircle : faMinusCircle}
                    onClick={goalType}
                    className="admin-config-icon"
                    // style={{ marginLeft: "276px", cursor: "pointer" }}
                  />
                </p>
                <Collapse in={goalNameType}>
                  <div id="collapsePanel">
                    <div className="inner">
                      <div className="box">
                        {goalTypeData?.map((item, index) => (
                          <div>
                            <label>Goal Field Name</label>
                            &emsp;
                            <input
                              type="text"
                              className="input-border"
                              placeholder="Type a goal field name"
                              style={
                                item.disabled
                                  ? {
                                      cursor: "no-drop",
                                      backgroundColor: "lightgray",
                                    }
                                  : null
                              }
                              onChange={(e) => handleGoalType(e, index)}
                              disabled={item.disabled}
                              value={item?.goalfield_name}
                            />
                            <FontAwesomeIcon
                              icon={faAsterisk}
                              style={{ marginLeft: "45px", width: "10px" }}
                              className="star-mendatory"
                            />
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{
                                marginLeft: "45px",
                                width: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => goalFieldDelete(item?.id)}
                              className="star-mendatory"
                            />
                          </div>
                        ))}
                        <button
                          className="add-button"
                          onClick={handleAddGoalType}
                          // disabled={goalTypeData[goalTypeData.length -1]?.goalfield_name}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add Type
                        </button>
                        <br />
                        <button
                          className="save-button"
                          onClick={handleSaveType}
                          // disabled={goalTypeData[goalTypeData.length -1]?.goalfield_name}
                        >
                          <FontAwesomeIcon icon={faSave} /> Save
                        </button>
                        &emsp;
                        <button
                          className="cancel-button-config"
                          onClick={() => cancelAction()}
                        >
                          <FontAwesomeIcon icon={faTimes} /> Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>

                <br />
                <p className="shade" onClick={goalName}>
                  Add Expression Name
                  <FontAwesomeIcon
                    icon={!name ? faPlusCircle : faMinusCircle}
                    onClick={goalName}
                    className="admin-config-icon"
                    // style={{ marginLeft: "263px", cursor: "pointer" }}
                  />
                </p>
                <Collapse in={name}>
                  <div id="collapsePanel">
                    <div className="inner">
                      <div className="box">
                        {expressionData?.map((item, index) => (
                          <div>
                            <label>Add Expression Name</label>
                            &emsp;
                            <input
                              type="text"
                              placeholder="Type a expression name"
                              className="input-border"
                              style={
                                item.disabled
                                  ? {
                                      cursor: "no-drop",
                                      backgroundColor: "lightgray",
                                    }
                                  : null
                              }
                              onChange={(e) => handleExpressionName(e, index)}
                              disabled={item.disabled}
                              value={item?.expression_name}
                            />
                            <FontAwesomeIcon
                              icon={faAsterisk}
                              style={{ marginLeft: "45px", width: "10px" }}
                              className="star-mendatory"
                            />
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{
                                marginLeft: "45px",
                                width: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => goalExpresssionDelete(item?.id)}
                              className="star-mendatory"
                            />
                          </div>
                        ))}
                        <button
                          className="add-button"
                          onClick={handleAddExpression}
                          // disabled={!expressionData[expressionData.length -1]?.expression_name}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add Expression
                        </button>
                        <br />
                        <button
                          className="save-button"
                          onClick={handleSaveExpression}
                          // disabled={!expressionData[expressionData.length -1]?.expression_name}
                        >
                          <FontAwesomeIcon icon={faSave} /> Save
                        </button>
                        &emsp;
                        <button
                          className="cancel-button-config"
                          onClick={() => cancelAction()}
                        >
                          <FontAwesomeIcon icon={faTimes} /> Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>

                <br />
                <p className="shade" onClick={operatorName}>
                  Add Logical Operators
                  <FontAwesomeIcon
                    icon={!operator ? faPlusCircle : faMinusCircle}
                    onClick={operatorName}
                    className="admin-config-icon"
                    // style={{ marginLeft: "259px", cursor: "pointer" }}
                  />
                </p>
                <Collapse in={operator}>
                  <div id="collapsePanel">
                    <div className="inner">
                      <div className="box">
                        {operatorData?.map((item, index) => (
                          <div>
                            <label>Operator</label>
                            &emsp;
                            <input
                              type="text"
                              placeholder="Type a operator name"
                              className="input-border"
                              style={
                                item.disabled
                                  ? {
                                      cursor: "no-drop",
                                      backgroundColor: "lightgray",
                                      width: "138px",
                                    }
                                  : {
                                      width: "138px",
                                    }
                              }
                              onChange={(e) => handleOperatorChange(e, index)}
                              disabled={item.disabled}
                              value={item?.operator_name}
                            />
                            &emsp;
                            <input
                              type="text"
                              placeholder="Type a operator"
                              className="input-border"
                              style={
                                item.disabled
                                  ? {
                                      cursor: "no-drop",
                                      backgroundColor: "lightgray",
                                      width: "138px",
                                    }
                                  : {
                                      width: "138px",
                                    }
                              }
                              onChange={(e) => handleOperatorChange1(e, index)}
                              disabled={item.disabled}
                              value={item?.operator}
                            />
                            <FontAwesomeIcon
                              icon={faAsterisk}
                              style={{ marginLeft: "45px", width: "10px" }}
                              className="star-mendatory"
                            />
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{
                                marginLeft: "45px",
                                width: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => goalOperatorDelete(item?.id)}
                              className="star-mendatory"
                            />
                          </div>
                        ))}
                        <button
                          className="add-button"
                          onClick={handleAddOperator}
                          // disabled={!(operatorData[operatorData.length -1]?.operator_name && operatorData[operatorData.length -1]?.operator)}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add Operator
                        </button>
                        <br />
                        <button
                          className="save-button"
                          onClick={handleOperatorSave}
                          // disabled={!(operatorData[operatorData.length -1]?.operator_name && operatorData[operatorData.length -1]?.operator)}
                        >
                          <FontAwesomeIcon icon={faSave} /> Save
                        </button>
                        &emsp;
                        <button
                          className="cancel-button-config"
                          onClick={() => cancelAction()}
                        >
                          <FontAwesomeIcon icon={faTimes} /> Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>

                <br />
                <p className="shade" onClick={arithemeticOperators}>
                  Add Arithemetic Operators
                  <FontAwesomeIcon
                    icon={!arithemeticOperator ? faPlusCircle : faMinusCircle}
                    onClick={arithemeticOperators}
                    className="admin-config-icon"
                    // style={{ marginLeft: "223px", cursor: "pointer" }}
                  />
                </p>
                <Collapse in={arithemeticOperator}>
                  <div id="collapsePanel">
                    <div className="inner">
                      <div className="box">
                        {arithemeticData?.map((item, index) => (
                          <div>
                            <label>Arithemetic Operator</label>
                            &emsp;
                            <input
                              type="text"
                              placeholder="Type an operator name"
                              className="input-border"
                              style={
                                item.disabled
                                  ? {
                                      cursor: "no-drop",
                                      backgroundColor: "lightgray",
                                    }
                                  : null
                              }
                              onChange={(e) =>
                                handleArithematicChange(e, index)
                              }
                              disabled={item.disabled}
                              value={item?.operator}
                            />
                            <FontAwesomeIcon
                              icon={faAsterisk}
                              style={{ marginLeft: "45px", width: "10px" }}
                              className="star-mendatory"
                            />
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{
                                marginLeft: "45px",
                                width: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() => arithematicDelete(item?.id)}
                              className="star-mendatory"
                            />
                          </div>
                        ))}
                        <button
                          className="add-button"
                          onClick={handleArithmeticOpt}
                          // disabled={!arithemeticData[arithemeticData.length -1]?.operator}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add Operator
                        </button>
                        <br />
                        <button
                          className="save-button"
                          onClick={handleSaveArthOperator}
                          // disabled={!arithemeticData[arithemeticData.length -1]?.operator}
                        >
                          <FontAwesomeIcon icon={faSave} /> Save
                        </button>
                        &emsp;
                        <button
                          className="cancel-button-config"
                          onClick={() => cancelAction()}
                        >
                          <FontAwesomeIcon icon={faTimes} /> Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
                <br />

                <p className="shade" onClick={dataTypeName}>
                  Add Data Type
                  <FontAwesomeIcon
                    icon={!dataType ? faPlusCircle : faMinusCircle}
                    onClick={dataTypeName}
                    className="admin-config-icon"
                    // style={{ marginLeft: "313px", cursor: "pointer" }}
                  />
                </p>
                <Collapse in={dataType}>
                  <div id="collapsePanel">
                    <div className="inner">
                      <div className="box">
                        {typeData?.map((item, index) => (
                          <div>
                            <label>Field Type</label>
                            &emsp;
                            <input
                              type="text"
                              placeholder="Type a field type"
                              className="input-border"
                              style={
                                item.disabled
                                  ? {
                                      cursor: "no-drop",
                                      backgroundColor: "lightgray",
                                    }
                                  : null
                              }
                              onChange={(e) => handleDataType(e, index)}
                              disabled={item.disabled}
                              value={item?.field_type}
                            />
                            <FontAwesomeIcon
                              icon={faAsterisk}
                              style={{ marginLeft: "45px", width: "10px" }}
                              className="star-mendatory"
                            />
                            <FontAwesomeIcon
                              icon={faTrash}
                              style={{
                                marginLeft: "45px",
                                width: "10px",
                                cursor: "pointer",
                              }}
                              onClick={() =>  typeDelete(item.id)}
                              className="star-mendatory"
                            />
                          </div>
                        ))}
                        <button
                          className="add-button"
                          onClick={handleAddField}
                          // disabled={!typeData[typeData.length -1]?.field_type}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add Expression
                        </button>
                        <br />
                        <button
                          className="save-button"
                          onClick={handleSaveField}
                          // disabled={!typeData[typeData.length -1]?.field_type}
                        >
                          <FontAwesomeIcon icon={faSave} /> Save
                        </button>
                        &emsp;
                        <button
                          className="cancel-button-config"
                          onClick={() => cancelAction()}
                        >
                          <FontAwesomeIcon icon={faTimes} /> Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>

            <div className="admin-config-section">
              <h2 className="admin-config-section-title">
                Configuration for Student Data Source
              </h2>
              <div className="admin-config-accordion-list">
                  <p className="shade" onClick={queryCriterias}>
                    Add Query Criterias
                    <FontAwesomeIcon
                      icon={!query ? faPlusCircle : faMinusCircle}
                      onClick={queryCriterias}
                      className="admin-config-icon"
                      // style={{ marginLeft: "279px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={query}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {queryData?.map((item, index) => (
                            <div>
                              <label>Query Criterias</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  !item.active
                                    ? {
                                      cursor: "no-drop",
                                      backgroundColor: "lightgray",
                                    }
                                    : null
                                }
                                disabled={item.active ? false : true}
                                onChange={(e) => handleAddQueryChange(e, index)}
                                value={item?.name}
                              />
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "45px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => queryDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddQuery}
                            // disabled={!queryChange}
                            // disabled={queryData[queryData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Criteria
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveCriteria}
                            // disabled={!queryChange}
                            // disabled={queryData[queryData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                  <br />

                  <p className="shade" onClick={contactReason}>
                    Add Reason to Contact (For Recruiters)
                    <FontAwesomeIcon
                      icon={!reason ? faPlusCircle : faMinusCircle}
                      onClick={contactReason}
                      className="admin-config-icon"
                      // style={{ marginLeft: "135px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={reason}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {reasonData?.map((item, index) => (
                            <div>
                              <label>Reason</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                onChange={(e) =>
                                  handleAddReasonChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "45px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => reasonDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddReason}
                            // disabled={reasonData[reasonData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Reason
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveReason}
                            // disabled={reasonData[reasonData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>

                  <br />
                  <p className="shade" onClick={manualName}>
                    Add Query Criterias Manual
                    <FontAwesomeIcon
                      icon={!manual ? faPlusCircle : faMinusCircle}
                      onClick={manualName}
                      // style={{ marginLeft: "221px", cursor: "pointer" }}
                      className="admin-config-icon"
                    />
                  </p>
                  <Collapse in={manual}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {manualData?.map((item, index) => (
                            <div>
                              <label>Query Criteria Manual</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                // style={
                                //   item.active
                                //     ? null
                                //     : {
                                //       cursor: "no-drop",
                                //       backgroundColor: "lightgray",
                                //     }
                                // }
                                disabled={item.active ? false : true}
                                onChange={(e) =>
                                  handleAddManualChange(e, index)
                                }
                                value={item?.name}
                              />
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "45px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => manualDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddManual}
                            // disabled={manualData[manualData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Query Criteria
                            Manual
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveManual}
                            // disabled={manualData[manualData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>

                  <br />
                  <p className="shade" onClick={genderName}>
                    Add Gender
                    <FontAwesomeIcon
                      icon={!gender ? faPlusCircle : faMinusCircle}
                      onClick={genderName}
                      // style={{ marginLeft: "335px", cursor: "pointer" }}
                      className="admin-config-icon"
                    />
                  </p>
                  <Collapse in={gender}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {genderData?.map((item, index) => (
                            <div>
                              <label>Gender Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddGenderChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "45px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => genderDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddGender}
                            // disabled={genderData[genderData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Gender
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveGender}
                            // disabled={genderData[genderData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>

                  <br />
                  <p className="shade" onClick={ethnicityName}>
                    Add Ethnicity
                    <FontAwesomeIcon
                      icon={!ethnicity ? faPlusCircle : faMinusCircle}
                      onClick={ethnicityName}
                      // style={{ marginLeft: "324px", cursor: "pointer" }}
                      className="admin-config-icon"
                    />
                  </p>
                  <Collapse in={ethnicity}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {ethnicityData?.map((item, index) => (
                            <div>
                              <label>Ethnicity Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddEthnicityChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "45px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => ethnicityDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddEthnicity}
                            // disabled={ethnicityData[ethnicityData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Ethnicity
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveEthnicity}
                            // disabled={ethnicityData[ethnicityData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>

                  <br />
                  <p className="shade" onClick={interestName}>
                    Add Interests
                    <FontAwesomeIcon
                      icon={!interest ? faPlusCircle : faMinusCircle}
                      onClick={interestName}
                      // style={{ marginLeft: "325px", cursor: "pointer" }}
                      className="admin-config-icon"
                    />
                  </p>
                  <Collapse in={interest}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {interestData?.map((item, index) => (
                            <div>
                              <label>Interest Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddInterestChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <button
                                className={
                                  !item.active
                                    ? "cancel-button-config"
                                    : "save-button"
                                }
                                onClick={() => handleAddInterestDisabled(index)}
                              >
                                {item.active ? (
                                  <span>
                                    <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                    Enabled
                                  </span>
                                ) : (
                                  <span>
                                    <FontAwesomeIcon icon={faTimesCircle} />{" "}
                                    Disabled
                                  </span>
                                )}
                              </button>
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "30px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => interestDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddInterest}
                            // disabled={interestData[interestData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Interest
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveInterest}
                            // disabled={interestData[interestData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>

                  <br />
                  <p className="shade" onClick={academicsName}>
                    Add Academics
                    <FontAwesomeIcon
                      icon={!academics ? faPlusCircle : faMinusCircle}
                      onClick={academicsName}
                      className="admin-config-icon"
                      // style={{ marginLeft: "306px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={academics}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {academicsData?.map((item, index) => (
                            <div>
                              <label>Academics Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddAcademicsChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <button
                                className={
                                  !item.active
                                    ? "cancel-button-config"
                                    : "save-button"
                                }
                                onClick={() =>
                                  handleAddAcademicsDisabled(index)
                                }
                              >
                                {item.active ? (
                                  <span>
                                    <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                    Enabled
                                  </span>
                                ) : (
                                  <span>
                                    <FontAwesomeIcon icon={faTimesCircle} />{" "}
                                    Disabled
                                  </span>
                                )}
                              </button>
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "20px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => academicsDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddAcademics}
                            // disabled={academicsData[academicsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Academics
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveAcademics}
                            // disabled={academicsData[academicsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>

                  <br />
                  <p className="shade" onClick={activitiesName}>
                    Add Activities
                    <FontAwesomeIcon
                      icon={!activities ? faPlusCircle : faMinusCircle}
                      onClick={activitiesName}
                      className="admin-config-icon"
                      // style={{ marginLeft: "320px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={activities}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {activitiesData?.map((item, index) => (
                            <div>
                              <label>Activities Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddActivitiesChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <button
                                className={
                                  !item.active
                                    ? "cancel-button-config"
                                    : "save-button"
                                }
                                onClick={() =>
                                  handleAddActivitiesDisabled(index)
                                }
                              >
                                {item.active ? (
                                  <span>
                                    <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                    Enabled
                                  </span>
                                ) : (
                                  <span>
                                    <FontAwesomeIcon icon={faTimesCircle} />{" "}
                                    Disabled
                                  </span>
                                )}
                              </button>
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "30px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => activitiesDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddActivities}
                            // disabled={activitiesData[activitiesData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Activities
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveActivities}
                            // disabled={activitiesData[activitiesData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>

                  <br />
                  <p className="shade" onClick={athleticsName}>
                    Add Athletics
                    <FontAwesomeIcon
                      icon={!athletics ? faPlusCircle : faMinusCircle}
                      onClick={athleticsName}
                      className="admin-config-icon"
                      // style={{ marginLeft: "324px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={athletics}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {athleticsData?.map((item, index) => (
                            <div>
                              <label>Athletics Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddAthleticsChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <button
                                className={
                                  !item.active
                                    ? "cancel-button-config"
                                    : "save-button"
                                }
                                onClick={() =>
                                  handleAddAthleticsDisabled(index)
                                }
                              >
                                {item.active ? (
                                  <span>
                                    <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                    Enabled
                                  </span>
                                ) : (
                                  <span>
                                    <FontAwesomeIcon icon={faTimesCircle} />{" "}
                                    Disabled
                                  </span>
                                )}
                              </button>
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "30px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => athleticsDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddAthletics}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Athletics
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveAthletics}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                  <br />

                  {/* International */}

                  {/* <p className="shade" onClick={countryName}>
                    Add Country
                    <FontAwesomeIcon
                      icon={!country ? faPlusCircle : faMinusCircle}
                      onClick={countryName}
                      className="admin-config-icon"
                      // style={{ marginLeft: "324px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={country}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {countryData?.map((item, index) => (
                            <div>
                              <label>Country Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddCountryChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <button
                                className={
                                  !item.active
                                    ? "cancel-button-config"
                                    : "save-button"
                                }
                                onClick={() =>
                                  handleAddCountryDisabled(index)
                                }
                              >
                                {item.active ? (
                                  <span>
                                    <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                    Enabled
                                  </span>
                                ) : (
                                  <span>
                                    <FontAwesomeIcon icon={faTimesCircle} />{" "}
                                    Disabled
                                  </span>
                                )}
                              </button>
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "30px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => countryDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddCountry}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add countries
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveCountry}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                  <br />

                  <p className="shade" onClick={certificateName}>
                    Add Board Certification
                    <FontAwesomeIcon
                      icon={!certificate ? faPlusCircle : faMinusCircle}
                      onClick={certificateName}
                      className="admin-config-icon"
                      // style={{ marginLeft: "324px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={certificate}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {certificateData?.map((item, index) => (
                            <div>
                              <label>Board Certificate Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddCertificateChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <button
                                className={
                                  !item.active
                                    ? "cancel-button-config"
                                    : "save-button"
                                }
                                onClick={() =>
                                  handleAddCertificateDisabled(index)
                                }
                              >
                                {item.active ? (
                                  <span>
                                    <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                    Enabled
                                  </span>
                                ) : (
                                  <span>
                                    <FontAwesomeIcon icon={faTimesCircle} />{" "}
                                    Disabled
                                  </span>
                                )}
                              </button>
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "30px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => certificateDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddCertificate}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Board Certification
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveCertificate}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                  <br />

                  <p className="shade" onClick={englishName}>
                    Add English Test
                    <FontAwesomeIcon
                      icon={!english ? faPlusCircle : faMinusCircle}
                      onClick={englishName}
                      className="admin-config-icon"
                      // style={{ marginLeft: "324px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={english}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {englishData?.map((item, index) => (
                            <div>
                              <label>English Test Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddEnglishChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <button
                                className={
                                  !item.active
                                    ? "cancel-button-config"
                                    : "save-button"
                                }
                                onClick={() =>
                                  handleAddEnglishDisabled(index)
                                }
                              >
                                {item.active ? (
                                  <span>
                                    <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                    Enabled
                                  </span>
                                ) : (
                                  <span>
                                    <FontAwesomeIcon icon={faTimesCircle} />{" "}
                                    Disabled
                                  </span>
                                )}
                              </button>
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "30px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => englishDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddEnglish}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add English Test
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveEnglish}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                  <br />

                  <p className="shade" onClick={levelName}>
                      Add Desired Degree
                    <FontAwesomeIcon
                      icon={!level ? faPlusCircle : faMinusCircle}
                      onClick={levelName}
                      className="admin-config-icon"
                      // style={{ marginLeft: "324px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={level}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {levelData?.map((item, index) => (
                            <div>
                              <label>Desired Degree Value</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a new value"
                                className="input-border"
                                style={
                                  item.active
                                    ? null
                                    : {
                                        cursor: "no-drop",
                                        backgroundColor: "lightgray",
                                      }
                                }
                                onChange={(e) =>
                                  handleAddLevelChange(e, index)
                                }
                                disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <button
                                className={
                                  !item.active
                                    ? "cancel-button-config"
                                    : "save-button"
                                }
                                onClick={() =>
                                  handleAddLevelDisabled(index)
                                }
                              >
                                {item.active ? (
                                  <span>
                                    <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                    Enabled
                                  </span>
                                ) : (
                                  <span>
                                    <FontAwesomeIcon icon={faTimesCircle} />{" "}
                                    Disabled
                                  </span>
                                )}
                              </button>
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "30px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => levelDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddLevel}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Desired Degree
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveLevel}
                            // disabled={athleticsData [athleticsData.length -1]?.name}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse> */}
                  <br />


                  {/* <p className="shade" onClick={courseName}>
                    Add Course Concentration Requirements
                    <FontAwesomeIcon
                      icon={!course ? faPlusCircle : faMinusCircle}
                      onClick={courseName}
                      className="admin-config-icon"
                      // style={{ marginLeft: "117px", cursor: "pointer" }}
                    />
                  </p>
                  <Collapse in={course}>
                    <div id="collapsePanel">
                      <div className="inner">
                        <div className="box">
                          {courseData?.map((item, index) => (
                            <div>
                              <label>Concentration</label>
                              &emsp;
                              <input
                                type="text"
                                placeholder="Type a name"
                                className="input-border"
                                style={{ width: "120px" }}
                                //   item.active
                                //     ?
                                //     {
                                //       width: "120px",
                                //     }
                                //     : {
                                //       width: "120px",
                                //       cursor: "no-drop",
                                //       backgroundColor: "lightgray",
                                //     }
                                // }
                                onChange={(e) =>
                                  handleAddConcentrationChange(e, index)
                                }
                                // disabled={item.active ? false : true}
                                value={item?.name}
                              />
                              &emsp;
                              <input
                                ref={valueNameRef}
                                type="text"
                                placeholder="Select Goal"
                                className="input-border"
                                style={{ width: "120px" }}
                                //   item.active
                                //     ?
                                //     {
                                //         width: "120px",
                                //     }
                                //     :
                                //       {
                                //         cursor: "no-drop",
                                //         backgroundColor: "lightgray",
                                //         width: "120px",
                                //       }
                                // }
                                value={item.goal}
                                onChange={() =>
                                  handleChangeConcentration(index)
                                }
                                // disabled={item.active ? false : true}
                                autoComplete="off"
                              />
                              <FontAwesomeIcon
                                icon={faAsterisk}
                                style={{ marginLeft: "45px", width: "10px" }}
                                className="star-mendatory"
                              />
                              <FontAwesomeIcon
                                icon={faTrash}
                                style={{
                                  marginLeft: "45px",
                                  width: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => concentrationDelete(item?.id)}
                                className="star-mendatory"
                              />
                            </div>
                          ))}
                          <button
                            className="add-button"
                            onClick={handleAddCourse}
                            // disabled={(courseData[courseData.length -1]?.name && courseData[courseData.length -1]?.goal)}
                          >
                            <FontAwesomeIcon icon={faPlus} /> Add Concentration
                          </button>
                          <br />
                          <button
                            className="save-button"
                            onClick={handleSaveCourse}
                            // disabled={(courseData[courseData.length -1]?.name && courseData[courseData.length -1]?.goal)}
                          >
                            <FontAwesomeIcon icon={faSave} /> Save
                          </button>
                          &emsp;
                          <button
                            className="cancel-button-config"
                            onClick={() => cancelAction()}
                          >
                            <FontAwesomeIcon icon={faTimes} /> Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default ConfigurationList;
